import { useState } from 'react'
import { ItemBiblioteca } from '../../../core/types/graphql'

export const useSelectViewItem = () => {
  const [selectedViewItem, setSelectedViewItem] = useState<ItemBiblioteca>()

  const onCloseViewItem = () => {
    setSelectedViewItem(undefined)
  }

  const onSelectViewItem = item => {
    setSelectedViewItem(item)
  }

  return {
    selectedViewItem,
    onCloseViewItem,
    onSelectViewItem
  }
}
